/**
 * 正規化ルール (SPEC.md「用語・正規化ルール」)
 *
 * 正規化はサーバー側で必ず行う。クライアント側の正規化は
 * UXのための先行表示にすぎず、信用しない。
 */

// 制御文字 (Cc) と書式文字 (Cf)
const CONTROL_CHARS = /[\p{Cc}\p{Cf}]/gu
const WHITESPACE = /\s+/gu

/** 単語・読み方に共通する 1〜3 の処理 */
function normalizeCommon(input: string): string {
  return input
    .normalize('NFKC')
    .replace(CONTROL_CHARS, '')
    .replace(WHITESPACE, ' ')
    .trim()
}

/** ひらがな (U+3041–U+3096) をカタカナに変換する */
export function hiraganaToKatakana(input: string): string {
  let out = ''
  for (const ch of input) {
    const cp = ch.codePointAt(0)!
    out += cp >= 0x3041 && cp <= 0x3096 ? String.fromCodePoint(cp + 0x60) : ch
  }
  return out
}

/**
 * 単語の正規化。
 * 正規化後の文字列をそのまま主キー兼表示文字列として使う。
 */
export function normalizeWord(input: string): string {
  return normalizeCommon(input).toLowerCase()
}

/**
 * 読み方の正規化。単語と同じ処理のあと、ひらがなをカタカナに寄せる。
 */
export function normalizePronunciation(input: string): string {
  return hiraganaToKatakana(normalizeCommon(input)).toLowerCase()
}

/** コードポイント数 */
export function codePointLength(s: string): number {
  return [...s].length
}
